import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
export default {
  name: "createFormModal",
  components: {
    VPagination,
  },
  props: { studyId: String,
    templateList: {
      type: Array,
      default: () => [],
    },
   },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      createdformid: "",
      formName: "",
      idtoken: "",
      formData: {
        therapeuticAreaId: "",
        formCategoryId: "",
      }, 
      therapeuticAreas: [],
      formCategories: [],
      errors: {
        formName: false
      },
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.idtoken = store.getters.getIdToken
    document.body.style.overflow = "hidden"
    this.fetchTherapeuticAreas();
    this.fetchFormCategories();
  },
  unmounted() {
    document.body.style.overflow = "auto"
  },
  methods: {
    // async createForm() {
    //   this.errors.formName = !this.formName;
    //   if (this.errors.formName) {
    //     return;
    //   }
    //   else {
    //     await axios
    //       .post(
    //         `${this.baseurl}/forms/templatedesign/createform`,
    //         {
    //           "formName": this.formName,
    //           "folderName": "",
    //           "folderId": this.studyId
    //         },
    //         {
    //           headers: {
    //             Authorization: "Bearer " + this.idtoken,
    //             "Content-Type": "application/json",
    //           }
    //         }
    //       )
    //       .then((res) => {
    //         this.createdformid = res;
    //         this.createtemplate();
    //         // this.$emit("closeModal")
    //       })
    //       .catch((err) => {
    //         console.error("Form error:", err);
    //       });
    //   }

    // },
    async createForm() {
  // Reset errors
  this.errors.formName = !this.formName;
  console.log("Form Name:", this.formName);
if (this.formName=="") {
    // Show error if formName is empty
    this.errors.formNameMessage = "Form name is required.";
    return;
  } 
  else{
  // Check if templateName already exists in templateList
  const isDuplicate = this.templateList.some(
    (template) => template.templateName.toLowerCase() === this.formName.toLowerCase()
  );

   if (isDuplicate) {
    // Show error if formName already exists
    this.errors.formNameMessage = "A template with this name already exists.";
    this.errors.formName = true;
    return;
  } else {
    // Clear any previous error messages
    this.errors.formNameMessage = "";
    this.errors.formName = false;

    try {
      const response = await axios.post(
        `${this.baseurl}/forms/templatedesign/createform`,
        {
          formName: this.formName,
          folderName: "",
          folderId: this.studyId,
        },
        {
          headers: {
            Authorization: "Bearer " + this.idtoken,
            "Content-Type": "application/json",
          },
        }
      );

      this.createdformid = response.data; // Adjust based on your API response structure
      await this.createtemplate(); // Call the next function
      this.$emit("closeModal"); // Emit closeModal event
    } catch (err) {
      console.error("Form error:", err);
      this.errors.formNameMessage = "An error occurred while creating the form.";
    }
  }
}
},

    async createtemplate() {
      let selectedArea = this.therapeuticAreas.find(
        (area) => area.id === this.formData.therapeuticAreaId
      );
      let selectedCategory = this.formCategories.find(
        (cat) => cat.id === this.formData.formCategoryId
      );
      let data = {
        templateId: "",
        templateName: this.formName,
        languageCode: "en",
        totalPages: 0,
        version: "1.0",
        isDeleted: false,
        language: "English",
        folder: "",
        createdUserEmail: store.getters.getEmailIs,
        createdAt: new Date(),
        createdUserId: null,
        lastModifiedUserEmail: null,
        lastModifiedAt: null,
        lastModifiedUserId: null,
        formname: this.formName,
        formId: this.createdformid["data"],
        pages: [],
        studyId: this.studyId,
        formCategory: selectedCategory ? selectedCategory.formCategory : "",
        formCategoryId: this.formData.formCategoryId,
        therapeuticArea: selectedArea ? selectedArea.name : "",
        therapeuticAreaId: this.formData.therapeuticAreaId,

      };
      await axios
        .post(
          `${this.baseurl}/forms/templatedesign/saveformtemplate`,
          data,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            }
          }
        )
        .then((res) => {
          console.log(res.data);
          // alert("Form created successfully.");
          alert(this.$t('navigations.form created successfully'))
          this.$emit("closeModal");
          this.$emit("SubmitForm");
          this.$emit('sendIdToParent', res.data);
          // emitIdToParent(res.data);
        })
        .catch((err) => {
          console.error("Form error:", err);
        });
    },
    async emitIdToParent(idToSend) {
      this.$emit('sendIdToParent', idToSend);
    },
    async fetchTherapeuticAreas() {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/master/getalltherapeuticareas`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.therapeuticAreas = response.data.filter(
          (area) => area.isActive
        ).sort((a, b) => a.name.localeCompare(b.name));

      } catch (error) {
        console.error("Error fetching therapeutic areas:", error);
      }
    },

    async fetchFormCategories() {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/master/getallformcategories`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.formCategories = response.data.filter(
          (category) => category.isActive
        ).sort((a, b) => a.formCategory.localeCompare(b.formCategory));
      } catch (error) {
        console.error("Error fetching form categories:", error);
      }
    }


  }

}